<template>
  <div class="inquiry_warp">
    <van-overlay :show="inquiryShow" >
      <div class="focus_main">
        <div class="focus_pop">
          <div class="inquiry_title">回复</div>
          <div class="focut_content">
            <van-field
              type="textarea"
              class="text_area "
              placeholder="请输入回复内容"
              :autosize=" { maxHeight:'1.6rem', minHeight:'1.6rem'}"
              placeholder-class="placeholder"
              fixed="true"
              v-model="content"
              name="text"
              maxlength="100"
              show-word-limit
            />
          </div>
          <div class="submit_btn">
            <span @click="resetForm">取消</span>
            <span @click="submit">提交</span>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
export default {
  name: "order",
  components:{
  },
  data() {
    return {
      content:'',
      inquiryShow:false,
      exInfo:{},
      helloMsg:'',
    } 
  },
  computed:{
    ...mapGetters({
      exhibitorId:'company/getExhibitorId',
      companyId:'company/getCompanyId',
      userInfo:'getUserInfo',
      exhibitionId:'getExhibitionId'
    }),
  },
  methods:{
   ...mapActions({
     putSayHello:'my/putSayHello',
   }),
   open(item){
     console.log(item,'----')
     this.helloMsg = item;
     this.inquiryShow=true;
   },
   async submit(){
      if(!this.content){ 
        this.$toast('请输入回复内容');  
        return; 
      }
      let body = {
          sayHelloId:this.helloMsg.id,
          toContent:this.content,
          toState:1,
      };
      let result = await this.putSayHello(body);
      if(result.result){
        this.$toast.success('回复成功');
        this.$emit('resetInit',this.helloMsg.id)
      } else {
        this.$toast.fail(result.message || '回复失败');
      }
      this.resetForm();
   },
   resetForm(){
     this.content="";
     this.inquiryShow=false;
   }
  }
};
</script>


<style lang="scss" scoped>
  .inquiry_warp{
    z-index: 200;
    position: relative;
    .focus_main{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .focus_pop {
      width: 5.6rem;
      height: 4rem;
      padding: 0.35rem 0.35rem 0;
      background: #fff;
      border-radius: 0.15rem;
      position: relative;
      .inquiry_title {
        font-size: 0.3rem;
        text-align: center;
        color: #333;
        line-height: 1.2;
        margin-bottom: 0.23rem;
        letter-spacing: 1px;
        padding-left: 1px;
        font-weight: 600;
      }
      .submit_btn {
        height: .9rem;
        width: 100%;
        display: flex;
        align-items: center;
        position: absolute;
        border-top: 1px solid #d2d3d5;
        left: 0;
        right: 0;
        bottom: 0;
        span {
          display: flex;
          justify-content: center;
          align-items: center;
          height: .89rem;
          border: none;
          border-radius: 0;
          color: #333;
          font-size: 0.3rem;
          width: 100%;
          &:first-child {
            border-right: 1px solid #d2d3d5;
          }
          &:last-child {
            color: #fe5502;
          }
        }
      }
      .focut_content {
        .input_read {
          background: #eee;
          color: #666;
          padding: 0 0.2rem;
          display: flex;
          justify-content: space-between;
          height: 0.7rem;
          margin-bottom: 0.2rem;
          align-items: center;
          // line-height: 0.7rem;
          p {
            font-size: 0.26rem;
            width: 30%;
          }
          ::v-deep
          .van-field{
            padding: 0;
            background: transparent;
            line-height: inherit;
            .van-field__word-limit{
              margin-top: 0;
              font-size: 0.24rem;
            }
            input {
            // width: 70%;
            color: #666;
            outline: none;
            border: none;
            background: transparent;
            
            text-align: right;
            // padding: 0.15rem 0;
            font-size: 0.26rem;
            box-sizing: border-box;
            // height: 35px;
            }
            input[type="tel"]{
              color: #666;
              background: #eee;
            }
          } 
        }
        .placeholder {
          font-size: .26rem;
        }
        ::v-deep .text_area {
          border: 1px solid #eee;
          height: 1.4rem;
          padding: 0.1rem 0.2rem;
          box-sizing: border-box;
          width: 100%;
          font-size: 0.26rem;
          line-height: 0.38rem;
          color: #333;
           .van-field__body {
            .van-field__control {
              min-height: 0.95rem;
              font-size: 0.26rem;
              line-height: 0.38rem;
              &::-webkit-input-placeholder {
                /* WebKit browsers */
                color: #bfbfbf;
                font-size: 0.26rem;
              }
              &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: #bfbfbf;
                font-size: 0.26rem;
              }
              &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: #bfbfbf;
                font-size: 0.26rem;
              }
              &:-ms-input-placeholder {
                /* Internet Explorer 10+ */
                color: #bfbfbf;
                font-size: 0.26rem;
              }
            }
          }
          .van-field__word-limit {
            font-size: 0.24rem;
            margin-top:-0.05rem;
          }
          
        }
      }
    }
  }
.group-type{
    margin-bottom: .4rem;
    span{
        // width: 50px;
        // height: 25px;
        font-size: .26rem;
        color: #666;
        display: inline-block;
        border: solid 1px #ccc;
        border-radius: .1rem;
        padding: .13rem 0;
        margin-right: .1rem;
        width: .9rem;
        text-align: center;
    }
    span:last-child{
         margin-right: 0;
    }
    .activeNames{
       background-color: #1890ff;
       border-color: #1890ff; 
       color: #fff;
    }
}
 .focus_pop_finish {
    width: 5.6rem;
    padding: 0.6rem 1rem ;
    background: #fff;
    border-radius: 0.15rem;
    text-align: center;
    font-size: .24rem;
	line-height: 1.5;
	color: #333;
 }
</style>

